import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes }  from 'react-router-dom';
import { LoadingDialog, useFetchExpress } from '@phoxer/react-components';
import MainWrapper from '../Components/Wrappers/MainWrapper';

const HomePage = lazy(() => import('./Home'));
const Recap = lazy(() => import('./Recap'));
const Register = lazy(() => import('./Register'));
const CropProtection = lazy(() => import('./CropProtection'));
const Westbred = lazy(() => import('./Westbred'));
const Dekalb = lazy(() => import('./Dekalb'));
const Seminis = lazy(() => import('./Seminis'));
const EmbedPage = lazy(() => import('../Components/Embed')); 
const AutomationDemo = lazy(() => import('./AutomationDemos'));

const SeminisOnion = () => {
    const { result, loading } = useFetchExpress('assets/jsons/page-data.json');

    if (loading || result === null) {
        return <LoadingDialog show={true} />;
    };

    return (<BrowserRouter basename={process.env.REACT_APP_DOMAIN}>
        <MainWrapper menu={result.menu}>
            <Suspense fallback={<LoadingDialog show={true} />}>
                <Routes>
                    <Route path="*" element={<HomePage pageData={result} />} />
                    <Route path="register" element={<Register pageData={result} />} />
                    <Route path="recap" element={<Recap pageData={result} />} />
                    <Route path="crop-protection" element={<CropProtection pageData={result} />} />
                    <Route path="westbred" element={<Westbred pageData={result} />} />
                    <Route path="dekalb" element={<Dekalb pageData={result} />} />
                    <Route path="seminis" element={<Seminis pageData={result} />} />
                    <Route path="disease-management" element={<EmbedPage page="disease-management" />} />
                    <Route path="breeding" element={<EmbedPage page="breeding" />} />
                    <Route path="commercial-offerings" element={<EmbedPage page="commercial-offerings" />} />
                    <Route path="water-management" element={<EmbedPage page="water-management" />} />
                    <Route path="automation-demos" element={<AutomationDemo pageData={result} />} />
                    <Route path="automation-demos/:cid" element={<AutomationDemo pageData={result} />} />
                </Routes>
            </Suspense>
        </MainWrapper>
    </BrowserRouter>);
}

export default SeminisOnion;

/*
<Route path="disease-management" element={<EmbedPage page="disease-management" />} />
                    <Route path="automation-demos" element={<AutomationDemo />} />
                    <Route path="automation-demos/:cid" element={<AutomationDemo />} />
                    */
